'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { MotionAnimatedAutoHeight } from '@/components/ui/motion-animated-auto-height';
interface MarketDetailSidebarProps {
  top: ReactNode;
  positions: ReactNode;
  prizePool: ReactNode;
  rewards: ReactNode;
  postResolution: boolean;
}
export function MarketDetailSidebar(t0) {
  const $ = _c(14);
  const {
    top,
    positions,
    prizePool,
    rewards,
    postResolution
  } = t0;
  let t1;
  if ($[0] !== postResolution || $[1] !== top) {
    t1 = <MotionAnimatedAutoHeight revealAfterExpand={true} animateChanges={postResolution} className="shrink-0" innerClassName="flex flex-col gap-3">{top}</MotionAnimatedAutoHeight>;
    $[0] = postResolution;
    $[1] = top;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== positions) {
    t2 = <MotionAnimatedAutoHeight revealAfterExpand={true} className="shrink-0" innerClassName="flex flex-col gap-3">{positions}</MotionAnimatedAutoHeight>;
    $[3] = positions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== prizePool) {
    t3 = <MotionAnimatedAutoHeight revealAfterExpand={true} className="shrink-0" innerClassName="flex flex-col gap-3">{prizePool}</MotionAnimatedAutoHeight>;
    $[5] = prizePool;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rewards) {
    t4 = <MotionAnimatedAutoHeight revealAfterExpand={true} className="shrink-0" innerClassName="flex flex-col gap-3">{rewards}</MotionAnimatedAutoHeight>;
    $[7] = rewards;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex flex-col [&>div:has(>div>*)~div>div:not(:empty)]:before:content-['']">{t1}{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}